import React from "react";
import {
    Form,
    Row,
    Col,
    Select,
    Space,
    Statistic,
    Card,
    Modal,
    message,
} from "antd";
import AdnInput from "../common/adnInput/AdnInput";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import { useNavigate } from "react-router-dom";
import {
    TypeProjectOptions,
    dateFormat,
} from "../common/GeneralConfigurations";
import {
    EditOutlined,
    DeleteOutlined,
    EuroOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnCard from "../common/adnCard/AdnCard";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnInputNumber from "../common/adnInputNumber/AdnInputNumber";
import AdnSubtitle from "../common/adnSubtitle/AdnSubtitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import { Link } from "react-router-dom";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import { Tag, Input, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import adnYesNoModal from "../common/adnYesNoModal/AdnYesNoModal";
import {
    BudgetValidation,
    CompanyValidation,
    DescriptionValidation,
    DurationValidation,
    EndDateValidation,
    NameValidation,
    PublishDateValidation,
    TypeValidation,
} from "./ProjectValidations";

function ProjectForm({
    event,
    companyData,
    form,
    technologyForm,
    teamMemberForm,
    onFinish,
    handleCancel,
    loading,
    submitProjectTechnology,
    handleSearchTecnology,
    handleSelectTecnology,
    searchOptions,
    setEvent,
    setVisible,
    visible,
    handleProjectTechnologySubmit,
    eventProjectTechnology,
    projectTechnologyData,
    projectTeamMemberData,
    handleDeleteTecnology,
    disabledPublishDate,
    disabledEndDate,
    disabledQuestionEndDate,
    handleDeleteTeamMember,
    addTeamMember,
    technologyOptions,
}) {
    const navigate = useNavigate();
    const columns = [
        {
            title: "Member Profile",
            dataIndex: "name",
            key: "name",
            width: "20%",
            sorter: false,
            render: (text, record) => (
                <Link to={`/teammember/${record.id}`}>{record.name}</Link>
            ),
        },
        {
            title: "Experience",
            dataIndex: "experienceName",
            key: "experienceName",
            width: "20%",
        },

        {
            title: "Price",
            dataIndex: "price",
            key: "price",
            width: "10%",
            sorter: false,
        },
        {
            title: "Allocation Hours",
            dataIndex: "allocationHours",
            key: "allocationHours",
            width: "20%",
        },
        {
            title: "Allocation Percentage",
            dataIndex: "allocationPercentage",
            key: "allocationPercentage",
            width: "20%",
        },
        {
            title: "Actions",
            key: "action",
            render: (record) => (
                <Space size="middle">
                    <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() =>
                            adnYesNoModal(() => handleDeleteTeamMember(record.id))
                        }
                    />
                </Space>
            ),
            width: "10%",
        },
    ];

    const columns2 = [
        {
            title: "Name",
            dataIndex: "technologyName",
            width: "30%",
            editable: true,
            sorter: false,
        },

        {
            title: "Action",
            key: "action",
            render: (record) => (
                <Space size="middle" align="center">
                    <DeleteOutlined
                        style={{ color: "red" }}
                        onClick={() =>
                            adnYesNoModal(() => handleDeleteTecnology(record.id))
                        }
                    />
                </Space>
            ),
            width: "3%",
        },
    ];
    return (
        <>
            <AdnPageTitle
                title={event == "add" ? "Adding Project" : "Edit Project"}
            />
            <AdnCard>
                <Row>
                    <AdnSubtitle text={"Details"} />
                </Row>
                <Form layout="vertical" form={form} onFinish={onFinish}>
                    <Row gutter={14}>
                        <Col span={12}>
                            <AdnInput
                                name="name"
                                label="Name"
                                placeholder={"Insert Name"}
                                rules={NameValidation}
                            />
                        </Col>

                        <Col span={6}>
                            <AdnDropdown
                                name="type"
                                label="Type"
                                options={TypeProjectOptions}
                                placeholder={"Select Type"}
                                rules={TypeValidation}
                            />
                        </Col>

                        <Col span={6}>
                            <AdnInputNumber
                                name="duration"
                                label={
                                    <>
                                        Duration
                                        <>
                                            <Tooltip title={`Duration in Days`}>
                                                <InfoCircleOutlined style={{ marginLeft: "10px" }} />
                                            </Tooltip>
                                        </>
                                    </>
                                }
                                placeholder={"Insert Duration"}
                                rules={DurationValidation}
                            />
                        </Col>
                    </Row>
                    <Row gutter={14}>
                        <Col span={4}>
                            <AdnDatePicker
                                name="publishDate"
                                label="Publish Date"
                                rules={PublishDateValidation}
                                disabledDate={disabledPublishDate}
                                format={dateFormat}
                            />
                        </Col>

                        <Col span={4}>
                            <AdnDatePicker
                                name="questionEndDate"
                                label="Question End Date"
                                disabledDate={disabledQuestionEndDate}
                                format={dateFormat}
                            />
                        </Col>

                        <Col span={4}>
                            <AdnDatePicker
                                name="endDate"
                                label="End Date"
                                rules={EndDateValidation}
                                disabledDate={disabledEndDate}
                                format={dateFormat}
                            />
                        </Col>

                        <Col span={6}>
                            <AdnDropdown
                                name="companyId"
                                label="Company"
                                options={companyData}
                                placeholder={"Select Company"}
                                rules={CompanyValidation}
                            />
                        </Col>

                        <Col span={6}>
                            <AdnInputNumber
                                name="budget"
                                label="Budget"
                                placeholder={"Insert Budget"}
                                addonAfter={<EuroOutlined />}
                                rules={BudgetValidation}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <AdnTextArea
                                name="description"
                                label="Description"
                                placeholder={"Description"}
                                maxLength={200}
                                showCount
                                rows={2}
                                rules={DescriptionValidation}
                            />
                        </Col>
                    </Row>
                    <br />
                    <br />
                    <AdnFormOptions handleCancel={handleCancel} />
                </Form>

                {event == "edit" ? (
                    <>
                        <Row style={{ marginTop: "5rem" }}>
                            <Col>
                                <AdnSubtitle text={"Team Members"} />
                            </Col>
                        </Row>
                        <Row>
                            <Col offset={22} span={2}>
                                <AdnAddButton handleClick={addTeamMember} />
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <AdnTable
                                    data={projectTeamMemberData}
                                    columns={columns}
                                    expandable={{
                                        expandedRowRender: (record) => (
                                            <p style={{ margin: 0 }}>{record.note}</p>
                                        ),
                                    }}
                                    rowClassName={(record, index) =>
                                        record.date == undefined
                                            ? ""
                                            : new Date(record.date) < new Date()
                                                ? "doneRow"
                                                : ""
                                    }
                                ></AdnTable>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: "5rem" }}>
                            <Col>
                                <AdnSubtitle text={"Project Tecnologies"} />
                            </Col>
                        </Row>

                        <Row>
                            <Col offset={22} span={2}>
                                <AdnAddButton
                                    handleClick={() => {
                                        technologyOptions();
                                        setVisible(true);
                                        technologyForm.setFieldsValue({ name: "" });
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <AdnTable data={projectTechnologyData} columns={columns2} />
                            </Col>
                        </Row>
                    </>
                ) : null}
            </AdnCard>

            <Modal
                title={"New Project Technology"}
                open={visible}
                onOk={handleProjectTechnologySubmit}
                cancelText={"Back"}
                okText={"Save"}
                onCancel={() => {
                    setVisible(false);
                }}
            >
                <Form
                    form={technologyForm}
                    name="technologyForm_in_modal"
                    layout="vertical"
                >
                    <Form.Item name={"TechnologyName"}>
                        <AdnAutoComplete
                            placeholder={"Search Technology..."}
                            valueId={"name"}
                            handleSearch={handleSearchTecnology}
                            handleSelect={handleSelectTecnology}
                            resultList={searchOptions}
                        ></AdnAutoComplete>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
export default ProjectForm;
